export type GridViewPermissionParams = {
  activeOrganizationId?: string
  scopeKind?: 'organization' | 'solo' | 'unresolved'
  userId?: string
  isGuest?: boolean
  isAdmin?: boolean
  createdByUserID?: string | null
}

export type GridViewPermissions = {
  canReadSharedViews: boolean
  canCreateSharedView: boolean
  canUpdateSharedView: boolean
  canDeleteSharedView: boolean
  canSetDefaultSharedView: boolean
}

export const resolveGridViewPermissions = ({
  activeOrganizationId,
  scopeKind,
  userId,
  isGuest = false,
  isAdmin = false,
  createdByUserID,
}: GridViewPermissionParams): GridViewPermissions => {
  const hasResolvedOrganizationScope =
    scopeKind === 'organization' && Boolean(activeOrganizationId)
  const isAuthenticatedMember =
    hasResolvedOrganizationScope && Boolean(userId) && !isGuest
  const canManageOwnView =
    isAuthenticatedMember &&
    Boolean(createdByUserID) &&
    createdByUserID === userId

  return {
    canReadSharedViews: isAuthenticatedMember,
    canCreateSharedView: isAuthenticatedMember,
    canUpdateSharedView: canManageOwnView || (isAuthenticatedMember && isAdmin),
    canDeleteSharedView: canManageOwnView || (isAuthenticatedMember && isAdmin),
    canSetDefaultSharedView: isAuthenticatedMember && isAdmin,
  }
}
